import type { SVGProps } from "react";
export function ChevronRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={20}
      viewBox="0 0 20 20"
      width={20}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m6.18 2.748a.726.726 0 0 1 .965-.115l.06.047 6.076 5.318a2.66 2.66 0 0 1 0 4.005l-6.077 5.317a.726.726 0 0 1 -.956-1.092l6.077-5.318a1.21 1.21 0 0 0 0-1.82l-6.077-5.318-.053-.052a.726.726 0 0 1 -.015-.972"
        fill="currentColor"
      />
    </svg>
  );
}
